import React, {type FC, useState} from 'react'
import {Link, useRouteLoaderData} from '@remix-run/react'
import cn from 'clsx'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'
import {useReportWidgetClick, useReportWidgetSeen} from '~/hooks/analytic-hooks'
import {getDomainConfig} from '~/domains'
import MetricCard from './metric-card'

const Metrics: FC = () => {
  const {language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const {styles: domainStyles} = getDomainConfig(domain, locale)
  const metrics = translations.ImprovedHomePage.Metrics.qualityMetrics
  const [openedMetricId, setOpenedMetricId] = useState('')
  const reportWidgetClicked = useReportWidgetClick()
  const [sectionRef] = useReportWidgetSeen({
    widget_name: 'improved-home-metrics-section',
    widget_place: 'bottom',
  })

  const handleAboutClick = () => {
    reportWidgetClicked({
      widget_name: 'improved-home-metrics-about-button',
      widget_place: 'bottom',
      trigger_type: 'click',
    })
  }

  return (
    <section ref={sectionRef} className="bg-black py-10 tablet:py-5">
      <div className={cn(domainStyles.UTILS_MAIN_CONTAINER, 'mx-auto flex w-full flex-col gap-y-6')}>
        <div className="flex flex-col gap-y-2 tablet:gap-y-1">
          <span className="text-base font-semibold uppercase tracking-widest text-[#61C200] tablet:text-xs">
            {translations.ImprovedHomePage.Metrics.title}
          </span>
          <h2 className="text-[32px] font-bold capitalize text-white tablet:pr-4 tablet:text-[28px]">
            {translations.ImprovedHomePage.Metrics.howWeFindTheBest}
          </h2>
        </div>

        <div className="flex flex-row gap-x-3 gap-y-3 tablet:flex-col">
          {metrics.map((metric, index) => {
            const isOpen = openedMetricId === metric.id

            return (
              <MetricCard
                key={`${metric.id}-${index}`}
                metric={metric}
                isOpen={isOpen}
                cardIndex={index}
                onToggle={() => setOpenedMetricId((currentMetric) => (currentMetric === metric.id ? '' : metric.id))}
              />
            )
          })}
        </div>

        <div className="flex flex-col gap-y-3">
          <span className="text-base font-semibold uppercase tracking-widest text-[#61C200] tablet:text-xs">
            {translations.ImprovedHomePage.Metrics.about}
          </span>
          <p className="max-w-[500px] text-base leading-[1.4] text-[#E7E7E7] tablet:max-w-full tablet:text-[13px] tablet:leading-tight">
            {translations.ImprovedHomePage.Metrics.description}
          </p>
          <Link
            to="/about"
            prefetch="intent"
            onClick={handleAboutClick}
            className="mt-2 inline-flex w-fit items-center justify-center rounded-full bg-[#1D3701] px-6 py-2 text-base font-normal text-[#78C02A] transition-colors hover:bg-[#4A8F05] tablet:px-6 tablet:py-2 tablet:text-sm"
          >
            {translations.ImprovedHomePage.Metrics.meetTheTeam}
          </Link>
        </div>
      </div>
    </section>
  )
}

export default Metrics
